import { FeatureType, ICAMSKey, IAPIResult, TextPack } from '../Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Utility/Utilities';
import * as events from '../Bus/Bus';
import { Photos } from '../Photos/Photos';
import { ActivityListRequestModel, ActivityListType, ActivityListFilter } from '../Activity/Activity';
import { ICAMSContact } from '../Contacts/ContactsModels';
import { Tasks_Assign } from './Tasks_Assign';
import { ReportModel, SystemType } from '../../Reports/ReportsModels';
import { ModalPrompts, PredefinedModalEnum } from '../Utility/ModalPrompts';

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Tasks_Edit {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private photos: Photos = new Photos();

    // ----------------------------------------------------------- //
    // Defaults
    // List of buttions in the action toolbar
    private actionBtns = {
        map: { btn: null, enable: false },
        accept: { btn: null, enable: false },
        reject: { btn: null, enable: false },
        complete: { btn: null, enable: false },
        //note: { btn: null, enable: false },
        condition: { btn: null, enable: false },
        //addIssue: { btn: null, enable: false },
        //annotate: { btn: null, enable: false }
    };

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected Tasks_Assign: Tasks_Assign) {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public openTaskViewPanel = (camsKey: ICAMSKey, showClass: string = 'show', closeCallback: Function, isConditionSurvey: Boolean): void => {
        const self = this;
  
        Utilities.BlockUI($('#featureDetailsPanel'));
        $('#featureDetailsPanel').addClass(showClass);
        $('#featureDetailsPanel').load(window.G_SITEFOLDERNAME +'/Tasks/TaskView', { taskID: camsKey.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }

            $('#taskViewPanelCloseBtn').on('click', function () { $('#featureDetailsPanel').removeClass(showClass); closeCallback(); });

            $('#taskViewOpenParentFormBtn').on("click", function () {
                Utilities.GetModal('#taskEditModal', ModalAction.Hide);
                const data: ICAMSKey = $(this).data("parentref");
                if (data.featureType == FeatureType.Maint) {
                    events.bus.publish(events.eventOpenMaintEditPanel(data));
                }
                else if (data.featureType == FeatureType.Route) {
                    events.bus.publish(events.eventOpenRouteEditPanel(data));
                }
                else if (data.featureType == FeatureType.Infra) {
                    events.bus.publish(events.eventOpenInfraEditPanel([data,null]));
                }
                else if (data.featureType == FeatureType.Land) {
                    events.bus.publish(events.eventOpenLandEditPanel(data));
                }
                this.blur();
            });
            $('#taskViewActivityBtn').on("click", function () {
                let model: ActivityListRequestModel = { ID: camsKey.code, ActivityListType: ActivityListType.TaskActivity, Filter: ActivityListFilter.All, Skip: 0, Take: 7 };
                events.bus.publish(events.eventShowActivityList([$(this), model, $('#taskEditModal')]));
                this.blur();
            });

            // MAP ZOOM BTN
            $('#featureDetailsPanel [data-zoommap]').on("click", function () {
                const data: ICAMSKey = $(this).data("zoommap");
                events.bus.publish(events.eventZoomToAnyFeature([data, true, null]));
            });

            // EDIT BTN
            $('#featureDetailsPanel [data-editatr]').on("click", function () {
                const data: ICAMSKey = $(this).data("editatr");
                $('#featureDetailsPanel').removeClass(showClass);
                closeCallback();

                events.bus.publish(events.eventOpenTasksEditPanel([data, null]));
            });

            // VIEW/ PRINT BTN
            $('#taskViewPrintBtn').on("click", function () {
                self.openTaskReport(camsKey);
            });

            // Override what the photo click does
            setTimeout(function () {
                $('#featureDetailsPanel #camsLibraryLinkContainer .card').off('click');
                $('#featureDetailsPanel #camsLibraryLinkContainer .card').on('click', function () {
                    var index = $('#featureDetailsPanel #camsLibraryLinkContainer .card').index($(this));
                    var imgs = $('#featureDetailsPanel #camsLibraryLinkModalGallery').find('img');

                    var url = imgs[index].getAttribute('src');
                    self.photos.showPhotoModal(url);
                });
            }, 500);

            // Check buttons
            self.bindButtons(camsKey);
            self.checkVisibleButtons(camsKey, isConditionSurvey);
        });
    }

    public openTaskCreateForm = (camsKeys: Array<ICAMSKey>, callback: Function): void => {
        const self = this;

        Utilities.BlockUI();
        $('#placeholder-for-taskmodals').load(window.G_SITEFOLDERNAME +'/Tasks/TaskCreate', { camsKeys: camsKeys }, function (response, status, xhr) {
            Utilities.UnBlockUI();

            Utilities.GetModal('#taskCreateModal', ModalAction.Create);
            //initialise photo uploader
            self.photos.setupUploader('#taskCreateModal');

            $('#taskCreateContactListBtn').on("click", function () {
                Utilities.GetModal('#taskCreateModal', ModalAction.Hide);
        
                self.Tasks_Assign.openAssignPanel([], {submitResponse: false, showUnassignBtn: false}, callback);
                function callback(c: ICAMSContact) {
                    if (c && c.ContactRef != null && c.ContactRef != "") {
                        $('#taskCreateForm [name="AssignedToType"]').val('');
                        $('#taskCreateForm [name="AssignedTo"]').val(c.ContactRef);
                        $('#taskCreateForm [name="assignToDescr"]').val(c.ListName);
                    }
                    else if (c) {
                        $('#taskCreateForm [name="AssignedToType"]').val(c.ContactType);
                        $('#taskCreateForm [name="AssignedTo"]').val('');
                        $('#taskCreateForm [name="assignToDescr"]').val(c.ContactTypeDescr);
                    }
                    Utilities.GetModal('#taskCreateModal', ModalAction.Show);
                }
            });

            // Get form validation
            Utilities.InitFormValidation($("#taskCreateForm"));

            $('#taskCreateSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#taskCreateForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("#taskCreateModal .modal-content"));
                let formData = new FormData(<any>$('#taskCreateForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Tasks/CreateTask',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                if (result.data.codes != null && result.data.codes.length > 1 && result.data.groupTasksEnabled == true) {

                                    ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.TasksCreateGroup }).then(r => {
                                        if (r.yes == true) {
                                            events.bus.publish(events.eventOpenTaskGroupCreatePanel(result.data.codes));
                                        }
                                        else {
                                        }
                                    }).catch(e => { });

                                }
                            }
                            else {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.GetModal('#taskCreateModal', ModalAction.Hide);
                            Utilities.UnBlockUI($("#taskCreateModal .modal-content"));
                            if (callback != null) callback(result.success);
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#taskCreateCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#taskCreateModal', ModalAction.Hide);
                if (callback != null) callback(false);
            });

            $('#taskCreateCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#taskCreateModal', ModalAction.Hide);
                if (callback != null) callback(false);
            });

        });
    }

    public openTaskEditForm = (camsKey: ICAMSKey, callback: Function): void => {
        const self = this;

        Utilities.BlockUI();
        $('#placeholder-for-taskmodals').load(window.G_SITEFOLDERNAME +'/Tasks/TaskEdit', { taskID: camsKey.code }, function (response, status, xhr) {
            Utilities.UnBlockUI();

            Utilities.GetModal('#taskEditModal', ModalAction.Create);
            //initialise photo uploader
            self.photos.setupUploader('#taskEditModal');

            $('#taskEditOpenParentFormBtn').on("click", function () {
                Utilities.GetModal('#taskEditModal', ModalAction.Hide);
                const data: ICAMSKey = $(this).data("parentref");
                if (data.featureType == FeatureType.Maint) {
                    events.bus.publish(events.eventOpenMaintEditPanel(data));
                }
                else if (data.featureType == FeatureType.Route) {
                    events.bus.publish(events.eventOpenRouteEditPanel(data));
                }
                else if (data.featureType == FeatureType.Infra) {
                    events.bus.publish(events.eventOpenInfraEditPanel([data,null]));
                }
                else if (data.featureType == FeatureType.Land) {
                    events.bus.publish(events.eventOpenLandEditPanel(data));
                }
                this.blur();
            });
            $('#taskEditActivityBtn').on("click", function () {
                let model: ActivityListRequestModel = { ID: camsKey.code, ActivityListType: ActivityListType.TaskActivity, Filter: ActivityListFilter.All, Skip: 0, Take: 7 };
                events.bus.publish(events.eventShowActivityList([$(this), model, $('#taskEditModal')]));
                this.blur();
            });
            $('#taskEditAssignBtn').on("click", function () {
                Utilities.GetModal('#taskEditModal', ModalAction.Hide);
                events.bus.publish(events.eventOpenTasksAssignPanel([[camsKey], { submitResponse: true }, function (r) {
                    self.openTaskEditForm(camsKey, callback);
                }]));
            });

            // Show/hide the REVIEW panel
            $('#taskEditModal [name = "RequiresReview"]').on("change", function () {
                if ($('#taskEditModal [name = "RequiresReview"]').is(":checked") == true) {
                    $('#taskEditReviewContainer').show();
                }
                else {
                    $('#taskEditReviewContainer').hide();
                }
            });
            if ($('#taskEditModal [name = "RequiresReview"]').is(":checked") != true) { $('#taskEditReviewContainer').hide(); }

            // Show/hide the INSPECTION panel
            $('#taskEditModal [name = "RequiresInspection"]').on("change", function () {
                if ($('#taskEditModal [name = "RequiresInspection"]').is(":checked") == true) {
                    $('#taskEditInspectionContainer').show();
                }
                else {
                    $('#taskEditInspectionContainer').hide();
                }
            });
            if ($('#taskEditModal [name = "RequiresInspection"]').is(":checked") != true) { $('#taskEditInspectionContainer').hide(); }

            // Save the original state of the edit form
            var originalFormData = $('#taskEditForm').serialize();

            // Get form validation
            Utilities.InitFormValidation($("#taskEditForm"));

            $('#taskEditSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#taskEditForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("#taskEditModal .modal-content"));
                let formData = new FormData(<any>$('#taskEditForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Tasks/UpdateTask',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Updated task!');
                                if (callback != null) callback(false);
                            }
                            else {
                                toastr.error('Failed to update task!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.GetModal('#taskEditModal', ModalAction.Hide);
                            Utilities.UnBlockUI($("#taskEditModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#taskEditCancelBtn').on('click', function (evt) {
                if (originalFormData !== $('#taskEditForm').serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) {
                            Utilities.GetModal('#taskEditModal', ModalAction.Hide); if (callback != null) callback(false);
                        }
                    });
                }
                else {
                    Utilities.GetModal('#taskEditModal', ModalAction.Hide); if (callback != null) callback(false);
                }
            });

            $('#taskEditCloseBtn').on('click', function (evt) {
                if (originalFormData !== $('#taskEditForm').serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) {
                            Utilities.GetModal('#taskEditModal', ModalAction.Hide); if (callback != null) callback(false);
                        }
                    });
                }
                else {
                    Utilities.GetModal('#taskEditModal', ModalAction.Hide); if (callback != null) callback(false);
                }
            });

            $('#taskEditDeleteBtn').on('click', function (evt) {
                self.deleteEntity(camsKey, callback);
            });

        });
    }

    // ----------------------------------------------------------- //
    // DELETE
    public deleteEntity = (data: ICAMSKey, callback: Function): void => {
        const self = this;
        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            Utilities.BlockUI();
            $.post('/Tasks/DeleteTask', data,
                function (result: IAPIResult) {
                    Utilities.UnBlockUI();
                    try {
                        if (result.success == true) {
                            events.bus.publish(events.eventClearAllHighlights());
                            events.bus.publish(events.eventRemoveAllMapInteractions());
                            events.bus.publish(events.eventResetAllButtons(true));

                            Utilities.GetModal('#taskEditModal', ModalAction.Hide);
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                            if (callback != null) callback(true);
                        }
                        else {
                            toastr.error('Delete failed: the record has child records - delete these before deleting the parent record.');
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    // ----------------------------------------------------------- //
    // Buttons
    private checkVisibleButtons = (data: ICAMSKey, isConditionSurvey: Boolean): void => {
        const self = this;

        // Reset all btns first
        Object.keys(this.actionBtns).forEach(k => { self.actionBtns[k].enable = false; });

        // Hide certain buttons if we never want to see them
        if ($('#myTasksRecordListOptionPoolTasks').is(':checked')==true) {
            self.actionBtns.accept.btn.parent().show();
            self.actionBtns.reject.btn.parent().hide();
            self.actionBtns.complete.btn.parent().hide();
            self.actionBtns.condition.btn.parent().hide();
            //self.actionBtns.addIssue.btn.parent().hide();
            //self.actionBtns.annotate.btn.parent().hide();

        } else {
            self.actionBtns.accept.btn.parent().hide();
            self.actionBtns.reject.btn.parent().show();
            if (isConditionSurvey == true) {
                self.actionBtns.complete.btn.parent().hide();
                self.actionBtns.condition.btn.parent().show();
            }
            else {
                self.actionBtns.condition.btn.parent().hide();
                self.actionBtns.complete.btn.parent().show();
            }
            //self.actionBtns.addIssue.btn.parent().show();
            //self.actionBtns.annotate.btn.parent().show();
        }

        self.actionBtns.map.enable = true;
        self.actionBtns.accept.enable = true;
        //self.actionBtns.note.enable = true;
        //self.actionBtns.annotate.enable = true;
        self.actionBtns.reject.enable = true;
        self.actionBtns.condition.enable = true;
        self.actionBtns.complete.enable = true;

        Object.keys(this.actionBtns).forEach(k => {
            if (self.actionBtns[k].enable == true) self.actionBtns[k].btn.prop("disabled", false);
            else self.actionBtns[k].btn.prop("disabled", true);
        });
    }

    private bindButtons = (data: ICAMSKey): void => {
        const self = this;

        self.actionBtns = {
            map: { btn: $('#tasksViewShowMapBtn'), enable: false },
            accept: { btn: $('#tasksViewAcceptBtn'), enable: false },
            reject: { btn: $('#tasksViewRejectBtn'), enable: false },
            complete: { btn: $('#tasksViewCompleteBtn'), enable: false },
            //note: { btn: $('#tasksViewNoteBtn'), enable: false },
            condition: { btn: $('#tasksViewConditionBtn'), enable: false },
            //addIssue: { btn: $('#tasksViewAddIssueBtn'), enable: false },
            //annotate: { btn: $('#tasksViewAnnotateBtn'), enable: false }
        };

        self.actionBtns.map.btn.on("click", function () {
            events.bus.publish(events.eventZoomToWKTandHighlight([[data.wkt], true, true, data.parentFeatureType]));
            this.blur();
        });

        self.actionBtns.accept.btn.on("click", function () {
            events.bus.publish(events.eventOpenTasksAcceptPanel(data));
            this.blur();
        });
        self.actionBtns.reject.btn.on("click", function () {
            events.bus.publish(events.eventOpenTasksRejectPanel(data));
            this.blur();
        });
        self.actionBtns.complete.btn.on("click", function () {
            if (data.featureType == FeatureType.Task) events.bus.publish(events.eventOpenTasksCompletePanel([data, true, function (r: IAPIResult) {
                if (r && r.success == true && data.parentFeatureType == FeatureType.Maint) {
                    if (r.data == 0) {
                        events.bus.publish(events.eventOpenMaintEditPanel({ code: data.parentCode, featureType: FeatureType.Maint }));
                        toastr.info("All tasks completed.");
                    }
                }
            }]));
            else if (data.featureType == FeatureType.TaskGroup) events.bus.publish(events.eventOpenTaskGroupsCompletePanel(data));
            this.blur();
        });
        //self.actionBtns.note.btn.on("click", function () {
        //    events.bus.publish(events.eventOpenNotificationQueryPanel([data, null]));
        //    this.blur();
        //});
        self.actionBtns.condition.btn.on("click", function () {
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventResetAllButtons(true));
            events.bus.publish(events.eventOpenConditionSurveyStartPanel(data));
            this.blur();
        });
        //self.actionBtns.annotate.btn.on("click", function () {
        //    events.bus.publish(events.eventShowAnnotationsForFeature([data, true]));
        //    this.blur();
        //});

        //self.actionBtns.addIssue.btn.on("click", function () { self.createNewIssuesOnRoute(data); this.blur(); });
        
    }

    private createNewIssuesOnRoute = (data: ICAMSKey): void => {
        const self = this;

        // Close the my tasks panel
        $('#myTasksRecordListPanel').removeClass('show');
        // Highlight the parent feature
        events.bus.publish(events.eventZoomToWKTandHighlight([[data.wkt], true, true, data.parentFeatureType]));
        // Start wizard at step 2
        let parentData: ICAMSKey = { code: data.parentCode, featureType: FeatureType.Route, wkt: data.wkt };
        events.bus.publish(events.eventNewMaintWizardStart([parentData, null, null]));
    }

    private openTaskReport = (camsKey: ICAMSKey): void => {
        // Setup variables
        let reportModel: ReportModel = { systemType: SystemType.MyTasks_Task_Single };
        var values: Array<string> = [];
        
        var selectedMsg = "Selected Record Only (1)";
        reportModel.reportParameters = [{ name: "codes", values: [camsKey.code] }];
        events.bus.publish(events.eventOpenReportOrSelectList([reportModel, selectedMsg]));
    }
}




